module.exports = [
    {
        title: 'Cookie usage',
        description: 'We use cookies to analyze data about our visitors, to improve our website, to display personalized content and to provide you with a great web experience. By using this website, you agree to this use.'
    }, {
        title: 'Strictly necessary cookies',
        description: 'These cookies are necessary for the functioning of the website, so it is not possible to disable them. Keep in mind that some pages will not work without these files. These cookies do not store any information that can be assigned to a specific person.',
        toggle: {
            value: 'necessary',
            enabled: true,
            readonly: true  //cookie categories with readonly=true are all treated as "necessary cookies"
        },
        cookie_table: [
            {
                col1: 'io',
                col2: location.hostname,
                col3: 'session',
            },
            {
                col1: 'easyevent_session',
                col2: location.hostname,
                col3: 'session',
            },
            {
                col1: 'XSRF-TOKEN',
                col2: location.hostname,
                col3: 'session',
            },

        ]
    },
    {
        title: 'Analytics & Performance cookies',
        description: 'These cookies are used to improve the operation of the website. They allow us to recognize and track the number of visitors and track how visitors use the site. These cookies do not collect information that could identify you. We use these tools to analyze and regularly improve the functionality of our website.',
        toggle: {
            value: 'analytics',
            enabled: false,
            readonly: false
        },
        cookie_table: [
            {
                col1: '^_ga',
                col2: 'Google.com',
                col3: '2 roky',
                is_regex: true
            },
            {
                col1: '_gid',
                col2: 'Google.com',
                col3: '1 den',
            }
        ]
    },
    {
        title: 'Internal analytics',
        description: 'We track visitor count and which pages they visit. This helps us make web better. We do not use any 3rd party tools for this. If you would like to anonymise all such tracking information stored, turn this section off.',
        toggle: {
            value: 'internal_analytics',
            enabled: false,
            readonly: false
        },
    }
]
